<template>
  <AtomicUiCheckbox
    :model-value="criteriaCheckbox"
    spacing="margin-bottom-xs"
    name="criteria-checkbox"
    :required="false"
    :options="criteriaOptions"
    @update:model-value="updateCheckboxCriteria"
  />
</template>

<script setup>
const filteringFacetsStore = useFilteringFacetsStore();
const { isMobile } = useDisplay();
const { facetByName, updateFacet, removeCheckBoxValuesByValue } = useSortFilter();
const { activeDropdown } = useFacetOptions();

const props = defineProps({
  name: {
    type: String,
    default: 'Category',
  },
});

const criteriaCheckbox = computed(() => {
  if (isMobile.value) {
    return facetByName(props.name)?.selectedValues;
  }
  return filteringFacetsStore.getFacetByName(props.name)?.selectedValues;
});

const criteriaOptions = computed(() => {
  if (isMobile.value) {
    return facetByName(props.name)?.values;
  }
  return filteringFacetsStore.getFacetByName(props.name)?.values;
});

const updateCheckboxCriteria = (selected) => {
  if (isMobile.value) {
    if (props.name === 'Price') {
      const customPrice = criteriaOptions.value.filter((value) => value.label.indexOf('Custom:') > -1);
      if (customPrice.length > 0) {
        const customPriceValue = customPrice[0].value;

        removeCheckBoxValuesByValue({
          name: props.name,
          value: customPriceValue,
        });

        updateFacet({
          name: props.name,
          selectedValues: selected.filter((value) => value !== customPriceValue),
        });
      }
    } else {
      updateFacet({
        name: props.name,
        selectedValues: selected,
      });
    }
  } else if (props.name === 'Price') {
    const customPrice = criteriaOptions.value.filter((value) => value.label.indexOf('Custom:') > -1);
    if (customPrice.length > 0) {
      const customPriceValue = customPrice[0].value;

      filteringFacetsStore.removeCheckboxValuesByValue({
        name: props.name,
        value: customPriceValue,
      });

      filteringFacetsStore.replaceSelectedValues({
        name: props.name,
        selectedValues: selected.filter((value) => value !== customPriceValue),
      });

      activeDropdown.value.focus();
    }
    filteringFacetsStore.getAllSelectedCriteria();
  } else {
    filteringFacetsStore.replaceSelectedValues({
      name: props.name,
      selectedValues: selected,
    });
    filteringFacetsStore.getAllSelectedCriteria();
  }
};
</script>
